// import React from "react";
// import { makeStyles } from "@material-ui/core/styles";
// import {Typography, Paper,List ,ListItem ,ListItemAvatar ,
//   ListItemText, Grid, IconButton} from "@material-ui/core";
// import {InsertDriveFile} from "@material-ui/icons";
// import { history } from '../../components/helpers/History';
// import {AccountCircle} from '@material-ui/icons';
// import { useSelector } from "react-redux";

// const useStyles = makeStyles((theme) => ({
//   root: {
//     flexGrow: 1,
//     margin: theme.spacing(4),
//   },
//   paper: {
//     padding: theme.spacing(2),
//     textAlign: "center",
//     color: theme.palette.text.secondary,
//   },
//   list: {
//     display: "flex",
//     flexDirection: "column",
//   },docButton: {
//     marginRight: theme.spacing(2),
//     background: '#8b5dc8',
//     textTransform : 'none',
//     color: '#FFF',
//     borderRadius: 10,
//     border: 0,
//     boxShadow: '0 0px 0px 0px rgba(0, 0, 0, 0)',
//   },doctorButton:{
//     marginRight: theme.spacing(2),
//     background: '#138bb9',
//     textTransform : 'none',
//     color: '#FFF',
//     borderRadius: 10,
//     border: 0,
//     boxShadow: '0 0px 0px 0px rgba(0, 0, 0, 0)',
//   },profileButton:{
//     marginRight: theme.spacing(2),
//     background: '#95c85d',
//     textTransform : 'none',
//     color: '#FFF',
//     borderRadius: 10,
//     border: 0,
//     boxShadow: '0 0px 0px 0px rgba(0, 0, 0, 0)',
//   },typography : {
//     padding: theme.spacing(4),
//   }
// }));

// export default function CenteredGrid() {
//   const classes = useStyles();
//   const user = useSelector(state => state.authentication.user);
//   console.log(user);
//   return (
//     <div className={classes.root}>
//  <Grid container spacing={3}>
//     <Grid item xs={12}>
//     <Typography component="h1" variant="h4" className={classes.typography}>
//         How are you, {user.firstName+ " "+user.lastName}
//       </Typography>
//       <Grid container spacing={3}>
//         <Grid item xs={12} sm={4}>
//           <Paper className={classes.paper}>
//             <List className={classes.list}>
//               <ListItem>
//                 <ListItemAvatar>
//                 <IconButton aria-label="show 11 new notifications" color="primary"
//                     className={classes.docButton}
//                     onClick={() => {
//                         history.push('/admin');
//                       }}
//                     >

//                         <InsertDriveFile />

//                     </IconButton>
//                 </ListItemAvatar>

//               </ListItem>
//               <ListItem>
//                 <ListItemText primary="Create new admin" secondary="" />
//               </ListItem>
//             </List>
//           </Paper>
//         </Grid>
//         <Grid item xs={12} sm={4}>
//           <Paper className={classes.paper}>
//             <List className={classes.list}>
//               <ListItem>
//                 <ListItemAvatar>
//                 <IconButton aria-label="show 11 new notifications" color="primary"
//                     className={classes.doctorButton}
//                     onClick={() => {
//                         history.push('/doctor');
//                       }}
//                     >

//                         <InsertDriveFile />

//                     </IconButton>
//                 </ListItemAvatar>

//               </ListItem>
//               <ListItem>
//                 <ListItemText primary="Create new doctor" secondary="" />
//               </ListItem>
//             </List>
//           </Paper>
//         </Grid>
//         <Grid item xs={12} sm={4}>
//           <Paper className={classes.paper}>
//             <List className={classes.list}>
//               <ListItem>
//                 <ListItemAvatar>
//                 <IconButton aria-label="show 11 new notifications" color="primary"
//                     className={classes.profileButton}
//                     onClick={() => {
//                         history.push('/patient');
//                       }}
//                     >

//                         <AccountCircle />

//                     </IconButton>
//                 </ListItemAvatar>

//               </ListItem>
//               <ListItem>
//                 <ListItemText primary="Create new patient" secondary="" />
//               </ListItem>
//             </List>
//           </Paper>
//         </Grid>
//       </Grid>
//     </Grid>
//   </Grid>
//     </div>
//   );
// }

import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import {
  Typography,
  Paper,
  List,
  ListItem,
  ListItemAvatar,
  ListItemText,
  Grid,
  IconButton,
  Box,
} from "@material-ui/core";
import { InsertDriveFile } from "@material-ui/icons";
import AppointmentHistory from "../appointments/AppointmentHistory";
import { history } from "../../components/helpers/History";
import { AccountCircle } from "@material-ui/icons";
import { useSelector } from "react-redux";

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    padding: theme.spacing(1),
  },
  appointmentHistoryPaper: {
    marginLeft: theme.spacing(2),
    padding: theme.spacing(1),
    width: "100%",
    height: "100%",
  },
  paper: {
    padding: theme.spacing(2),
    color: theme.palette.text.secondary,
    width: "100%",
    height: "100%",
  },
  list: {
    display: "flex",
    flexDirection: "column",
  },
  docButton: {
    marginRight: theme.spacing(2),
    background: "#8b5dc8",
    textTransform: "none",
    color: "#FFF",
    borderRadius: 10,
    border: 0,
    boxShadow: "0 0px 0px 0px rgba(0, 0, 0, 0)",
  },
  doctorButton: {
    marginRight: theme.spacing(2),
    background: "#138bb9",
    textTransform: "none",
    color: "#FFF",
    borderRadius: 10,
    border: 0,
    boxShadow: "0 0px 0px 0px rgba(0, 0, 0, 0)",
  },
  profileButton: {
    marginRight: theme.spacing(2),
    background: "#95c85d",
    textTransform: "none",
    color: "#FFF",
    borderRadius: 10,
    border: 0,
    boxShadow: "0 0px 0px 0px rgba(0, 0, 0, 0)",
  },
  typography: {
    padding: theme.spacing(4),
  },
}));

export default function CenteredGrid() {
  const classes = useStyles();
  const user = useSelector((state) => state.authentication.user);
  return (
    <div className={classes.root}>
      <Box color="primary.main">
        <Typography component="h1" variant="h4" className={classes.typography}>
          How are you, {user.firstName + " " + user.lastName} !
        </Typography>
      </Box>
      <Box p={{ xs: 2 }}>
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <Grid container spacing={3}>
              <Grid item xs={12} sm={4}>
                <Paper className={classes.paper}>
                  <List className={classes.list}>
                    <ListItem>
                      <ListItemAvatar>
                        <IconButton
                          aria-label="show 11 new notifications"
                          color="primary"
                          className={classes.docButton}
                          onClick={() => {
                            history.push("/admin");
                          }}
                        >
                          <InsertDriveFile />
                        </IconButton>
                      </ListItemAvatar>
                    </ListItem>
                    <ListItem>
                      <ListItemText primary="Create new admin" secondary="" />
                    </ListItem>
                  </List>
                </Paper>
              </Grid>
              <Grid item xs={12} sm={4}>
                <Paper className={classes.paper}>
                  <List className={classes.list}>
                    <ListItem>
                      <ListItemAvatar>
                        <IconButton
                          aria-label="show 11 new notifications"
                          color="primary"
                          className={classes.doctorButton}
                          onClick={() => {
                            history.push("/doctor");
                          }}
                        >
                          <InsertDriveFile />
                        </IconButton>
                      </ListItemAvatar>
                    </ListItem>
                    <ListItem>
                      <ListItemText primary="Create new doctor" secondary="" />
                    </ListItem>
                  </List>
                </Paper>
              </Grid>
              <Grid item xs={12} sm={4}>
                <Paper className={classes.paper}>
                  <List className={classes.list}>
                    <ListItem>
                      <ListItemAvatar>
                        <IconButton
                          aria-label="show 11 new notifications"
                          color="primary"
                          className={classes.profileButton}
                          onClick={() => {
                            history.push("/patient");
                          }}
                        >
                          <AccountCircle />
                        </IconButton>
                      </ListItemAvatar>
                    </ListItem>
                    <ListItem>
                      <ListItemText primary="Create new patient" secondary="" />
                    </ListItem>
                  </List>
                </Paper>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Box>
    </div>
  );
}
